export type QuestionModal = {
    id: string
    header: string
    body: string
}

export type EnquiryDefinitionId = 'make-claim' | 'cover-check' | 'book-virtual-gp' | 'book-physio'